import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const DELETE_QUERY = print(gql`
  mutation DeleteBlog($id: Int!) {
    deleteBlog(id: $id) {
      id
    }
  }
`);

export interface DeleteGql {
  deleteBlog: {
    id?: number;
  };
}
